import styled from 'styled-components'
import Text from '@/components/common/Text'
import { useTranslations } from 'next-intl'

const Wrap = styled.div`
  background-color: ${({ bgColor }) =>
    (bgColor === 'purple' && 'rgba(106, 103, 218, 0.1)') ||
    'rgba(245, 227, 65, 0.1)'};

  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 27px;
`

const WrapWithText = ({
  bgColor,
  textKey,
  color = 'yellow',
  text,
  size = '12',
  fileName = 'index',
}) => {
  const t = useTranslations(fileName)

  return (
    <Wrap bgColor={bgColor}>
      <Text size={size} weight="600" color={color} sizeT="20">
        {textKey && t(textKey)}
        {text}
      </Text>
    </Wrap>
  )
}

export default WrapWithText
